import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { CircularProgress } from '@mui/material'

type AlertDialogProps = {
  isLoading: boolean
  condition: boolean
  open: boolean
  handleClose: () => void
  handleConfirm: () => void
}
export const AlertDialog = ({
  isLoading,
  condition,
  open,
  handleClose,
  handleConfirm,
}: AlertDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Auto bow wave'}</DialogTitle>
      <DialogContent
        sx={{
          minWidth: '600px',
        }}
      >
        {isLoading ? (
          <CircularProgress />
        ) : (
          <DialogContentText id="alert-dialog-description">
            {condition
              ? 'Another workcentre is already running, please wait for it to complete.'
              : 'This will recalculate the capacity and may take a while tocomplete..'}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          disabled={isLoading || condition}
          autoFocus
        >
          Run auto bow wave
        </Button>
      </DialogActions>
    </Dialog>
  )
}
